import { requestTemplate } from 'api';
import { CancelToken } from 'axios';
import {
  INotification,
  INotificationV2,
  IEmailNotification,
  INotificationSettingsResponse,
  INotificationSettingsUpdatePayload,
  INotificationSettingsUpdateResponse,
} from 'interfaces';

type notificationPayload = {
  locale: string;
  page: number | string;
  per_page: number | string;
  sort?: any;
  filters?: any;
}

//NOTIFICATIONS
const getNotifications = ( locale: string, signal?: CancelToken ) => requestTemplate.get<INotification[]>(`/notifications/?locale=${locale}`, { cancelToken: signal });
const updateNotification = (payload: { notification_id: string, status: number }) => requestTemplate.put<INotification>('/notifications/', payload);

const getNotificationsUnviewedCount = (user_id: string) => requestTemplate.get<{count_of_new: number}>(`/notifications/get-metadata/`, {
  params: { filters: JSON.stringify([{"field":"user_id","value": user_id},{"field":"status","value":"NEW"}]) }
});
const viewAllNotifications = (user_id: string, created_at: string) => requestTemplate.put<any>(`/notifications/v2/`, {status: 1}, {
  params: { filters: JSON.stringify([
    {'field': 'user_id','value': user_id},
    {'field': 'status','value': 'NEW'},
    {'field': 'created_at','value': created_at},
  ])}
});

const getNotificationsV2 = (
  payload: notificationPayload, signal?: CancelToken
) => requestTemplate.get<INotificationV2>('/notifications/v2/',
  {
    cancelToken: signal,
    params: { ...payload, sort: '[{"field": "created_at", "direction": "desc"}]' }
  }
);

const getAllEmailNotificationsTypes = () =>
  requestTemplate.get<IEmailNotification[]>('/email_notifications/');

const getUserEmailNotifications = (roomId: string) =>
  requestTemplate.get<INotificationSettingsResponse>(`/email_notifications/${roomId}/`);

const updateUserEmailNotificationsSettings = (roomId: string, payload: INotificationSettingsUpdatePayload) =>
  requestTemplate.patch<INotificationSettingsUpdateResponse>(
    `/email_notifications/permitted-notifications/`,
    payload
  );

const notifications = {
  getNotifications,
  updateNotification,
  getNotificationsUnviewedCount,
  viewAllNotifications,
  getNotificationsV2,
  getAllEmailNotificationsTypes,
  getUserEmailNotifications,
  updateUserEmailNotificationsSettings,
};

export default notifications;
